// src/pages/Customer/components/SubscriptionTable.js
import { Table } from 'antd';
import dayjs from 'dayjs';

const SubscriptionTable = ({ data }) => {
  const columns = [
    {
      title: 'Product Name',
      dataIndex: ['product', 'name'],
      key: 'product_name',
    },
    {
      title: 'SKU',
      dataIndex: ['product', 'sku'],
      key: 'sku',
    },
    {
      title: 'Bundle',
      dataIndex: ['product', 'is_bundled'],
      key: 'is_bundled',
      render: (value) => value ? 'Yes' : 'No'
    },
    {
      title: 'Start Date',
      dataIndex: ['start_date'],
      key: 'start_date',
      render: (value) => dayjs(value).format('MM/DD/YYYY'),
    },
    {
      title: 'End Date',
      dataIndex: ['end_date'],
      key: 'end_date',
      render: (value) => dayjs(value).format('MM/DD/YYYY'),
    },
    {
      title: 'Terms',
      dataIndex: ['term'],
      key: 'term',
    },
    {
      title: 'Invoice Due Days',
      dataIndex: ['invoice_due_days'],
      key: 'invoice_due_days',
    },
    {
      title: 'Original Price',
      dataIndex: 'unit_price',
      key: 'unit_price',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'Discount (%)',
      dataIndex: 'discount_percentage',
      key: 'discount_percentage',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'Discount Amount',
      dataIndex: 'discount_amount',
      key: 'discount_amount',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'Sale Price',
      dataIndex: 'amount',
      key: 'amount',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
  ];

  return <Table columns={columns} dataSource={data} rowKey="id" pagination={false} size="small"/>;
};

export default SubscriptionTable;
